export const RESIZE_CUSTOM = "resize-custom";

function getViewportWidth() {
	// Prefer layout viewport width (matches how CSS breakpoints behave).
	// Avoid using visualViewport as the primary signal because it can change with pinch-zoom.
	return (
		document.documentElement.clientWidth ??
		window.innerWidth ??
		window.outerWidth ??
		window.visualViewport?.width
	);
}

export function resizeDetection() {
	const maxCount = 10;
	let count = 0;
	const throttledOnResize = throttle(onResize, 1000);

	function onResize() {
		// If this runs before <body> exists (script in <head>), avoid throwing and killing all later init.
		// Retry on the next frame until body is available.
		if (!document.body) {
			window.requestAnimationFrame(onResize);
			return;
		}

		if (count > maxCount) {
			window.removeEventListener("resize", throttledOnResize, true);
			window.removeEventListener("pageshow", throttledOnResize);
			return;
		}

		count++;

		document.body.classList.remove("desktop");
		document.body.classList.remove("mobile");
		document.body.classList.remove("tablet");

		const isMobile = checkIsMobile();
		if (isMobile) {
			document.body.classList.add("mobile");
		} else {
			document.body.classList.add("desktop");
		}

		setTimeout(() => {
			window.dispatchEvent(new CustomEvent(RESIZE_CUSTOM));
		}, 10);
	}

	const onVisibleChange = () => {
		if (document.visibilityState === "visible") {
			onResize();
		}
	};

	window.addEventListener("resize", throttledOnResize, true);
	window.addEventListener("pageshow", throttledOnResize);
	document.addEventListener("visibilitychange", onVisibleChange);
	onResize();
}

export function checkIsMobile() {
	return getViewportWidth() < 768;
}

function throttle(fn: () => void, wait: number) {
	let isCalled = false;
	return () => {
		if (!isCalled) {
			fn();
			isCalled = true;
			setTimeout(() => {
				isCalled = false;
			}, wait);
		}
	};
}
